module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-germany.0ec18359.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-germany.png
// module id = 2615
// module chunks = 11